module.exports = __webpack_public_path__ + "img/giant-robot.c81bfdfe.jpg";